import { WorkspaceEmailSendingDomainDetailRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

/**
 * `entri=auto` opens the guided DNS setup as soon as the page renders. The
 * add-domain flow sets it when it hands off here, and the page clears it once
 * consumed so returning doesn't reopen the flow.
 */
type SendingDomainDetailSearch = {
  entri?: 'auto';
};

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId',
)({
  component: WorkspaceEmailSendingDomainDetailRoute,
  // validateSearch replaces this route's search, so the incoming params are
  // spread through to preserve global ones the page doesn't own.
  // oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & SendingDomainDetailSearch => ({
    ...search,
    entri: search.entri === 'auto' ? 'auto' : undefined,
  }),
});
